import { ViewModel,View } from "binder"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { DebitCardSelectorViewModel } from "src/erp/arap/rawData/debitCard/debitCardSelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IPaymentInfoProvider } from "../IGateway";
import  { DebitGatewayView } from "./debitGateway-view"

export class DebitGatewayViewModel extends ViewModel implements IGateway{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    
    get title(): string {
        return 'کارت به کارت';
    }

    GetDefaultView(): View <ViewModel> {
        return new DebitGatewayView();
    }
    
    public getTypeId(): string {
        return "VM-12F4F69A-832A-437E-B9B6-434A97A9ECA8"
    }

    public set destinationCardNumber(v: string) { this._destinationCardNumber = v; } public get destinationCardNumber(): string { return this._destinationCardNumber;} private _destinationCardNumber: string;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;
    public set debitCardSelector(v: DebitCardSelectorViewModel) { this._debitCardSelector = v; } public get debitCardSelector(): DebitCardSelectorViewModel { return this._debitCardSelector;} private _debitCardSelector: DebitCardSelectorViewModel;

    initialLoad(): void {
        this.debitCardSelector = new DebitCardSelectorViewModel(this);
    }

    async save(dataProvider: IPaymentInfoProvider): Promise<any> {
        let paymentInfo = dataProvider.getBasePaymentInfoDto();
        return await ServerConnection.callServer('Complex/PaymentProcessServices/CreateDebitTransferPayment',{
            ProcessId:paymentInfo.processId,
            Attachments:paymentInfo.attachments.map(p=>{
                return{
                    Data:p.content,
                    Name:p.name
                }
            }),
            DestinationCardNumber:this.destinationCardNumber,
            SourceGatewayId:this.debitCardSelector.selectedItem.id,
            TraceCode:this.traceCode
        });
    }

    validate(): string[] {
        let result = [];
        if(stringIsNullOrEmpty(this.traceCode)){
            result.push('کد پیگیری وارد نشده است.');
        }
        if(stringIsNullOrEmpty(this.destinationCardNumber)){
            result.push('شماره کارت مقصد وارد نشده است.');
        }
        if(!stringIsNullOrEmpty(this.destinationCardNumber) && this.destinationCardNumber.length < 16){
            result.push(' شماره کارت بانکی مقصد معتبر نیست.')
        }
        if(this.debitCardSelector.selectedItem==null){
            result.push('کارت مبدا تعیین نشده است.');
        }
        return result;
    }
    
}
